
	import { defineComponent, ref, reactive, getCurrentInstance, onMounted } from 'vue'
	import { useTableScroll } from '@/common/mixins/useTableScroll'
	import { modeOptions, reviewColumns } from './config'
	import formatDate from '@/common/functions/formatDate'
	import { reviewList, appList } from './request'
	import Review from './components/Review.vue'
	import Detail from './components/Detail.vue'
	export default defineComponent({
		components: {
			Review,
			Detail
		},
		setup() {
			const loading = ref(false)
			const data = ref<any>([])
			const filter = reactive({
				corpName: ''
			})
			const instance = getCurrentInstance()
			const { scroll } = useTableScroll(instance)
			const columns = reviewColumns
			const fetchList = async () => {
				try {
					const params = {
						...filter
					}
					loading.value = true
					const res = await reviewList(params)
					loading.value = false
					data.value = res.data
				} catch (error) {
					loading.value = false
					console.log(error)
				}
			}
			const reviewState = reactive({
				visible: false,
				detail: null
			})
			const openReview = (record: any) => {
				reviewState.visible = true
				reviewState.detail = record
			}
			const handleClose = () => {
				reviewState.visible = false
				reviewState.detail = null
			}
			const detailState = reactive({
				visible: false,
				detail: null
			})
			const toDetail = (record: any) => {
				detailState.visible = true
				detailState.detail = record
			}
			const closeDetail = () => {
				detailState.visible = false
				detailState.detail = null
			}
			const apps = ref([])
			const fetchAppList = async () => {
				try {
					const params = {}
					const { data } = await appList(params)
					apps.value = data
				} catch (error) {
					console.log(error)
				}
			}
			onMounted(() => {
				fetchAppList()
				fetchList()
			})
			return {
				loading,
				data,
				filter,
				modeOptions,
				scroll,
				columns,
				fetchList,
				formatDate,
				openReview,
				reviewState,
				handleClose,
				closeDetail,
				fetchAppList,
				apps,
				toDetail,
				detailState
			}
		}
	})
